import { x, E, u, r as register, d } from "./preact-core.js";
import { C as CustomSelect } from "./custom-select.js";
import { l as layout } from "./layout-store.js";
class Modal extends x {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    E(() => {
      if (layout.modal.value == this.props.title) {
        this.setState({ isOpen: true });
        document.body.classList.add("modal-open");
      } else {
        this.setState({ isOpen: false });
        document.body.classList.remove("modal-open");
      }
    });
    if (window.location.hash === `#${this.props.title}`) {
      this.setState({ isOpen: true });
    }
    this.externalTriggers = document.querySelectorAll(
      `button[data-target="${this.props.title}"]`
    );
    this.externalTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        layout.modal.value = this.props.title;
      });
    });
  }
  componentDidUpdate(previousProps, previousState) {
    if (previousState.isOpen !== this.state.isOpen) {
      document.documentElement.style.overflow = this.state.isOpen ? "hidden" : "";
    }
  }
  close() {
    layout.modal.value = null;
  }
  render() {
    return /* @__PURE__ */ u("div", { class: `modal ${this.state.isOpen ? "active" : null}`, children: [
      /* @__PURE__ */ u("div", { class: "modal__panel ", children: [
        /* @__PURE__ */ u(
          "button",
          {
            class: "close",
            "data-close": "engraving-modal",
            onClick: this.close,
            children: /* @__PURE__ */ u("svg", { width: "20", height: "20", viewBox: "0 0 20 20", children: [
              /* @__PURE__ */ u("path", { d: "M1 1L20 20", stroke: "currentColor" }),
              /* @__PURE__ */ u("path", { d: "M20 1L1 20", stroke: "currentColor" })
            ] })
          }
        ),
        /* @__PURE__ */ u("div", { class: "modal__content", children: this.props.children })
      ] }),
      /* @__PURE__ */ u("div", { class: "__backdrop", onClick: this.close })
    ] });
  }
}
class LocaleStore {
  constructor() {
    this.localeDisplay = null;
  }
}
const localeStore = new LocaleStore();
class LocaleModal extends x {
  constructor(props) {
    super(props);
    this.layout = layout;
    this.localeStore = localeStore;
    this.localeStore.localeDisplay = "currency";
    this.activeCountry = d(JSON.parse(this.props.defaultCountry));
    this.userCountry = d(null);
    this.activeRegion = d(null);
    this.localeSet = d(false);
    this.selectedIso = d(this.props.currentIso.toString());
    this.selectedLanguage = d(this.props.currentLang.toString());
    this.browsingContext = d(null);
    this.setExternalTriggers();
    this.getSuggestions();
  }
  setExternalTriggers() {
    const currencyTriggers = document.querySelectorAll(
      `[data-target='locale--currency']`
    );
    const countryTriggers = document.querySelectorAll(
      `[data-target='locale--country']`
    );
    if (currencyTriggers) {
      currencyTriggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
          this.layout.modal.value = "locale";
          this.localeStore.localeDisplay = "currency";
        });
      });
    }
    if (countryTriggers) {
      countryTriggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
          this.layout.modal.value = "locale";
          this.localeStore.localeDisplay = "country--select";
        });
      });
    }
  }
  updateCurrency(e) {
    this.selectedIso.value = e.value.iso;
    this.forceUpdate();
  }
  updateRegion(e) {
    this.activeRegion.value = e.detail.data;
  }
  handleCountrySelect() {
    if (this.props.availableCountries.length > 1) {
      this.localeStore.localeDisplay = "currency";
    } else {
      this.layout.modal.value = null;
    }
  }
  getSuggestions() {
    if (!this.localeSet) {
      fetch("/browsing_context_suggestions.json?currency[enabled]=true", {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }).then((res) => res.json()).then((data) => {
        var _a, _b;
        this.browsingContext.value = data;
        const browsingCountry = (_a = this.browsingContext.value.detected_values) == null ? void 0 : _a.country_name;
        (_b = this.browsingContext.value.detected_values) == null ? void 0 : _b.country.handle;
        const correctLocale = this.props.availableCountries.filter(
          (country) => {
            return country.name == browsingCountry;
          }
        ).length;
        this.userCountry.value = this.props.availableCountries.find(
          (country) => country.name == browsingCountry
        );
        if (!correctLocale) {
          this.layout.modal.value = "locale";
          this.localeStore.localeDisplay = "country--warn";
        } else if (this.activeCountry.value.name != browsingCountry) {
          this.layout.modal.value = "locale";
          this.localeStore.localeDisplay = "currency";
        }
      });
    }
  }
  close() {
    this.layout.modal.value = null;
  }
  render() {
    return /* @__PURE__ */ u(Modal, { title: "locale", children: /* @__PURE__ */ u("div", { class: "locale-content", children: this.localeStore.localeDisplay == "country--warn" ? /* @__PURE__ */ u("div", { class: "country-content", children: [
      /* @__PURE__ */ u("p", { class: "heading", children: "Change Country/ Region" }),
      /* @__PURE__ */ u("p", { style: "margin-bottom:15px;margin-top:auto;", children: [
        "You are currently on the ",
        this.activeCountry ? this.activeCountry.value.name : "",
        " ",
        " store"
      ] }),
      /* @__PURE__ */ u("div", { style: "margin-bottom:15px;", children: /* @__PURE__ */ u(
        "button",
        {
          role: "button",
          onClick: () => {
            this.localeStore.localeDisplay = "country--select";
          },
          onTouchStart: () => {
            this.localeStore.localeDisplay = "country--select";
          },
          class: "btn btn--primary",
          children: "Change Country"
        }
      ) }),
      /* @__PURE__ */ u("div", { children: /* @__PURE__ */ u(
        "button",
        {
          role: "button",
          class: "btn btn--link",
          onClick: this.close,
          onTouchStart: this.close,
          children: "continue"
        }
      ) })
    ] }) : this.localeStore.localeDisplay == "country--select" ? /* @__PURE__ */ u("div", { class: "country-select__content", children: [
      /* @__PURE__ */ u("p", { class: "heading", children: "Set your Region" }),
      /* @__PURE__ */ u(
        CustomSelect,
        {
          title: "currency-selector",
          options: JSON.parse(this.localeStore.siteLocales),
          type: "locale",
          default: this.activeRegion.value,
          onSelected: this.updateRegion,
          searchEnabled: true
        }
      ),
      /* @__PURE__ */ u(
        "button",
        {
          onClick: this.handleCountrySelect,
          onTouchStart: this.handleCountrySelect,
          class: "btn btn--primary mt-auto",
          children: "Continue"
        }
      )
    ] }) : this.localeStore.localeDisplay == "currency" ? /* @__PURE__ */ u("div", { class: "currency-content", children: [
      /* @__PURE__ */ u("p", { class: "heading", children: "Set your Country" }),
      /* @__PURE__ */ u("p", { style: "margin-top:auto;margin-bottom:20px;", children: [
        "You are currently on the ",
        this.activeCountry.value ? this.activeCountry.value.name : "",
        " store"
      ] }),
      /* @__PURE__ */ u(
        "form",
        {
          method: "post",
          action: "/localization",
          enctype: "multipart/form-data",
          "accept-charset": "UTF-8",
          onSubmit: (e) => {
            e.preventDefault();
            this.close();
            e.target.submit();
          },
          children: [
            /* @__PURE__ */ u(
              CustomSelect,
              {
                title: "currency-selector",
                options: JSON.parse(this.props.availableCountries),
                default: this.userCountry.value ? this.userCountry.value : this.activeCountry.value,
                type: "locale",
                searchEnabled: true,
                onSelected: this.updateCurrency.bind(this)
              }
            ),
            /* @__PURE__ */ u(
              "input",
              {
                type: "hidden",
                name: "country_code",
                value: this.selectedIso.value
              }
            ),
            /* @__PURE__ */ u("input", { type: "hidden", name: "form_type", value: "localization" }),
            /* @__PURE__ */ u("input", { type: "hidden", name: "utf8", value: "✓" }),
            /* @__PURE__ */ u("input", { type: "hidden", name: "_method", value: "put" }),
            /* @__PURE__ */ u(
              "input",
              {
                type: "hidden",
                name: "return_to",
                value: window.location.pathname
              }
            ),
            /* @__PURE__ */ u("button", { type: "submit", class: "btn btn--primary", children: "Set Country" })
          ]
        }
      )
    ] }) : "" }) });
  }
}
const LocaleModal$1 = () => {
  register(LocaleModal, "locale-modal", [
    "available-countries",
    "default-country",
    "current-domain",
    "current-iso",
    "current-lang"
  ]);
};
LocaleModal$1();
